module.exports = __webpack_public_path__ + "./images/a16a7193cce2ac3038d9c60b598c5bd1.webp";